export default "__VITE_ASSET__Bj7ci7Zp__"